module.exports = __webpack_public_path__ + "static/assets/1c65e504a985831d05cbcf3a843126b8.svg";